import PropTypes from 'prop-types';
import {
  DUPLICATE_PEOPLE_ERROR,
  DUPLICATE_VESSEL_ERROR,
  MAX_UNREGISTERED_VESSEL_ERROR,
} from '../../constants/AppApiConstants';
import { ERROR_MESSAGE_URL, MESSAGE_URL, LANDING_URL } from '../../constants/AppUrlConstants';
import Auth from '../Auth';

const nonGeneric400Errors = [
  DUPLICATE_VESSEL_ERROR,
  DUPLICATE_PEOPLE_ERROR,
  MAX_UNREGISTERED_VESSEL_ERROR,
];

const handleAuthErrors = ({
  error,
  errorMessage,
  errorTitle,
  navigate,
  nonAuthRedirectUrl,
  redirectUrl,
  voyageId,
  ...props
}) => {
  const httpStatusCode = error?.response?.status;
  const previousState = props?.state?.state || {};

  if (httpStatusCode === 422 || httpStatusCode === 401) {
    const stateToPersist = { ...previousState, redirectURL: redirectUrl };
    Auth.logout();
    navigate(LANDING_URL, { state: { ...stateToPersist } });
    return;
  }

  if (httpStatusCode === 400 && !nonGeneric400Errors.includes(errorMessage)) {
    navigate(ERROR_MESSAGE_URL, { state: { id: voyageId } });
    return;
  }

  const newRedirectURL = httpStatusCode === 500 ? nonAuthRedirectUrl : redirectUrl;
  const stateToPersist = { ...previousState, redirectURL: newRedirectURL };

  navigate(MESSAGE_URL, {
    state: {
      title: errorTitle || 'Something has gone wrong',
      message: errorMessage || undefined,
      ...stateToPersist,
    },
  });
};

export default handleAuthErrors;

handleAuthErrors.propTypes = {
  error: PropTypes.object.isRequired,
  errorMessage: PropTypes.string,
  errorTitle: PropTypes.string,
  navigate: PropTypes.func,
  nonAuthRedirectUrl: PropTypes.string,
  redirectUrl: PropTypes.string,
  voyageId: PropTypes.string,
};
